module.exports = __webpack_public_path__ + "img/fertility.4ecb65d7.svg";